module.exports = __webpack_public_path__ + "static/media/personal_details_icon.6d1cc88a.svg";